import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

const buildQueryParams = ({ search, active, users }) => {
    return {
        filtro: search,
        filtroAtivo: active,
        usuarios: users,
    };
};

export default Object.assign(
    {
        apiUrl: "/aparelho",
        urlAdmin: "/aparelho",

        async delete({ id }) {
            const url = this.url(`/${id}`);

            return Vue.http.delete(url);
        },

        async alterPosition({ id, dest }) {
            const url = this.user(`/${id}/position/${dest}`);

            return Vue.http.put(url);
        },

        async get({ id }) {
            const url = this.url(`/${id}`);

            return Vue.http.get(url);
        },

        async types() {
            const url = this.url(`/tipos`);

            return Vue.http.get(url);
        },

        async userCreate({ nome, chave, tipo, localId, grupoId, accessPointCount = 1 }) {
            const url = this.url("/");

            return Vue.http.post(url, {
                nome,
                chave,
                tipo,
                localId,
                grupoId,
                accessPointCount
            });
        },

        async userUpdate({ id, nome, chave, localId, tipo, grupoId, accessPointCount = 1 }) {
            const url = this.url(`/${id}`);

            return Vue.http.put(url, {
                nome,
                chave,
                tipo,
                grupoId,
                localId,
                accessPointCount
            });
        },

        async list({ pagination, filters }) {
            const url = this.adminUrl(
                `/${pagination.page}/${pagination.amountPerPage}`
            );
            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query,
            });
        },

        async count({ filters }) {
            const url = this.adminUrl(`/paginacao`);
            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query,
            });
        },

        async getDevices() {
            const url = this.userUrl();
            return await Vue.http.get(url);
        },

        async create(data) {
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .post(this.adminUrl(), this.parseDevice(data))
                .catch((error) => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async update(data) {
            const device = this.parseDeviceEdit(data);
            const url = this.adminUrl(`/${device.id}`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.put(url, device).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async updateSettings({ id, data }) {
            const url = this.url(`/${id}/config`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.put(url, data).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async updateConnectionSupport(id, data) {
            const url = this.adminUrl(`/${id}/support`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.put(url, data).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async find({ id, userId }) {
            return this.formatDevice(
                await Vue.http.get(
                    this.userUrl({ path: `${this.url(userId)}/${id}`, userId })
                )
            );
        },

        async findConfiguration({ id, userId }) {
            const url = this.userUrl({ userId, path: `/${id}/config` });

            return await Vue.http.get(url);
        },

        async findConnectionSupport(id) {
            return await Vue.http.get(this.adminUrl(`/${id}/support`));
        },

        async activate(id) {
            const url = this.adminUrl(`/${id}/status`);
            return await Vue.http.put(url);
        },

        async getStatusBoxService(id) {
            const url = this.adminUrl(`/${id}/info-servico`);
            const response = await Vue.http.get(url);
            return response;
        },

        // async command(id) {
        //     const url = `${this.urlAdmin()}/${id}/command`;
        //     const response = await Vue.http.get(url);
        //     return response;
        // },

        async updateDevices(data) {
            const url = this.adminUrl(
                `${this.urlAdmin()}/${data.deviceId}/atualizar-box`
            );
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .post(url, { version: data.version })
                .catch((error) => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async disableWifeed(id) {
            const url = this.adminUrl(`/${id}/desativar-wifeed`);
            return await Vue.http.put(url);
        },

        async enableWifeed(id) {
            const url = this.adminUrl(`/${id}/ativar-wifeed`);
            return await Vue.http.put(url);
        },

        async updateLoginType(data) {
            let deviceId = data.deviceId || -1;
            const url = this.adminUrl(`/${deviceId}/tipos-login`);
            return await Vue.http.put(url, data.tiposLogin);
        },

        configFile({ id }) {
            return Vue.http({
                url: this.url(`/${id}/config-file`),
                method: "GET",
                responseType: "blob",
                params: {},
            });
        },

        async getCaptiveRedirectUrl(deviceId) {
            const url = this.url(`/${deviceId}/captive-link`);

            return Vue.http.get(url);
        },

        parseDevice({ general, address, tags }) {
            return {
                id: general.id,
                nome: general.name,
                tipo: general.deviceType,
                unidadeTimeout: general.timeoutType,
                timeout: general.timeout ? parseInt(general.timeout) : 0,
                estabelecimentoId: general.establishment,
                configurations: general.configurations,
                isSomenteMaiorIdade: general.isSomenteMaiorIdade,
                notes: general.notes,
                chave: general.chave,
                timezone: address.timezone,
                cep: address.zipCode,
                estado: address.state,
                cidade: address.city,
                bairro: address.neighborhood,
                logradouro: address.streetName,
                numero: address.streetNumber,
                tags: tags || [],
            };
        },

        parseDeviceEdit({ general, address, tags }) {
            return {
                id: general.id,
                nome: general.name,
                tipo: general.deviceType,
                unidadeTimeout: general.timeoutType,
                timeout: general.timeout ? parseInt(general.timeout) : 0,
                estabelecimentoId: general.establishment,
                configurations: general.configurations,
                isSomenteMaiorIdade: general.isSomenteMaiorIdade,
                notes: general.notes,
                chave: general.chave,
                timezone: address.timezone,
                cep: address.zipCode,
                estado: address.state,
                cidade: address.city,
                bairro: address.neighborhood,
                logradouro: address.streetName,
                numero: address.streetNumber,
                tags: tags || [],
            };
        },

        formatDevice(device) {
            let general = {};
            general.id = device.id;
            general.name = device.nome;
            (general.deviceType = device.tipo),
                (general.timeoutType = device.unidadeTimeout);
            general.timeout = device.timeout;
            general.establishment = device.estabelecimentoId;
            general.configurations = device.configurations;
            general.isSomenteMaiorIdade = device.isSomenteMaiorIdade;
            general.notes = device.notes;
            if (device.tiposLogin) {
                general.tiposLogin = JSON.parse(device.tiposLogin);
            } else {
                general.tiposLogin = [];
            }
            general.chave = device.chave;
            let address = {};
            address.timezone = device.timezone;
            address.zipCode = device.cep;
            address.state = device.estado;
            address.city = device.cidade;
            address.neighborhood = device.bairro;
            address.streetName = device.logradouro;
            address.streetNumber = device.numero;
            let tags = JSON.parse(device.tags || "[]");
            return { general, address, tags };
        },
    },
    base
);
